import React from "react";
import Divider from "@mui/material/Divider";

const InsetHorizontalDivider = (props) => (
  <Divider variant="inset" {...props} />
);

export default InsetHorizontalDivider;
